// device 已经更名成 system
export const device = {
  driverLogin: "Driver Login",
  loginMethod: "Login Method",
  qRCode: "QR Code",
  FaceID: "Face ID",
  NFCCard: "NFC Card",
  loginScanTime: "Login Scan Time (Sec) | Login Scan Time (Secs)",
  loginPictureDelay: "Login Picture Delay (Sec) | Login Picture Delay (Secs)",
  loginPictureDelayNoUnit: "Login Picture Delay",
  loginScanTimeNoUnit: "Login Scan Time",
  alerts: "Alerts",
  alertLanguage: "Alert Language",
  chineseSimplified: "Chinese (Simplified)",
  chineseTraditional: "Chinese (Traditional)",
  english: "English",
  french: "French",
  german: "German",
  italian: "Italian",
  japanese: "Japanese",
  spanish: "Spanish",
  wiFi: "Wi-Fi",
  wiFiMode: "Wi-Fi Mode",
  twoPointFourGHz: "2.4 GHz",
  fiveGHz: "5 GHz",
  AISettings: "AI Settings",
  peopleDetection: "People Detection",
  frontAlerts: "Front Alerts",
  rearAlerts: "Rear Alerts",
  leftAlerts: "Left Alerts",
  rightAlerts: "Right Alerts",
  warningAlertType: "Warning Alert Type",
  criticalAlertType: "Critical Alert Type",
  showDetectionBoxes: "Show Detection Boxes",
  fatigueAlerts: "Fatigue Alerts",
  phoneAlerts: "Phone Usage Alerts",
  smokingAlerts: "Smoking Alerts",
  allAlerts: "All Alerts",
  criticalAlertsOnly: "Critical Alerts Only",
  noAlerts: "No Alerts",
  sound: "Sound",
  voice: "Voice",
  yes: "Yes",
  no: "No",
  audio: "Audio",
  alertVolume: "Alert Volume",
  accessorySetting: "Accessory Settings",
  speedIndicatorUnits: "Speed Indicator Units",
  maximumSpeedLimit: "Maximum Speed Limit",
  maximumSpeedLimitWithUnit: "Maximum Speed Limit ({0})",
  displayLayout: "Display Layout",
  defaultDisplayLayout: "Display Layout without Sensors",
  displayLayoutWithReverseLightSensor:
    "Display Layout with Reverse Light Sensor",
  displayLayoutWithSpeedSensor: "Display Layout with Speed Sensor",
  alertDirection: "Alert Direction",
  metric: "Metric",
  imperial: "Imperial",
  USCustomary: "US Customary",
  twoCamera: "2 Camera",
  allCamera: "3 Camera",
  rearOnly: "Rear Only",
  rearDynamic: "Rear Dynamic",
  frontAndRearDynamic: "Front + Rear Dynamic",
  bothDirections: "Both Directions",
  movingDirectionOnly: "Moving Direction Only",
  outputVoltagePullHigh: "Pull High",
  outputVoltagePullLow: "Pull Low",
  /// todo change the value of GPO_NONE
  outputGPONone: "None",
  outputAllPDAlerts: "All PD Alerts",
  outputAllPDCriticalAlerts: "All PD Critical Alerts",
  outputAllPDWarningAlerts: "All PD Warning Alerts",
  outputAllFrontPDAlerts: "All Front PD Alerts",
  outputAllLeftPDAlerts: "All Left PD Alerts",
  outputAllRightPDAlerts: "All Right PD Alerts",
  outputAllRearPDAlerts: "All Rear PD Alerts",
  outputFrontPDCriticalAlerts: "Front PD Critical Alerts",
  outputFrontPDWarningAlerts: "Front PD Warning Alerts",
  outputLeftPDCriticalAlerts: "Left PD Critical Alerts",
  outputLeftPDWarningAlerts: "Left PD Warning Alerts",
  outputRightPDCriticalAlerts: "Right PD Critical Alerts",
  outputRightPDWarningAlerts: "Right PD Warning Alerts",
  outputRearPDCriticalAlerts: "Rear PD Critical Alerts",
  outputRearPDWarningAlerts: "Rear PD Warning Alerts",
  outputOverSpeedAlert: "Over Speed Alert",
  outputNoSeatBeltAlert: "No SeatBelt Alert",
  outputAuthorizedDriverAlert: "Authorized Driver Alert",
  outputUnauthorizedDriverAlert: "Unauthorized Driver Alert",
  outputFailedCriticalItemInspectionReportAlert:
    "Failed Critical Item Inspection Report Alert",
  outputAllGeofencingAlerts: "All Geofencing Alerts",
  outputEnterGeofenceZoneAlert: "Enter Geofence Zone Alert",
  outputExitGeofenceZoneAlert: "Exit Geofence Zone Alert",
  outputAllDSSAlerts: "All DSS Alerts",
  outputPhoneUsageAlert: "Phone Usage Alert",
  outputSmokingAlert: "Smoking Alert",
  outputFatigueAlert: "Fatigue Alert",
  outputBlockedCameraAlert: "Blocked Camera Alert",
  output1: "Output 1",
  output2: "Output 2",
  outputVoltage: "Output Voltage",
  outputCustomization: "Output Customization",
  driverSafetySystem: "Driver Safety System",
  pictureUpload: "Picture Upload",
  videoUpload: "Video Upload",
  alertAudio: "Alert Audio",
  geofenceAlerts: "Geofencing Alerts",
  speedingAlerts: "Speeding Alerts",
  seatbeltAlerts: "SeatBelt Unfastened Alerts",
  hardhatOffAlerts: "Hardhat Alerts",
  ExtendAICamera: "Driver Camera C100",
  cameraBlocked: "Camera Blocked Alerts",
  cameraShiftAlerts: "Camera Shift Alerts",
  leaveSeatAlerts: "Leave Seat Alerts",
  geofencing: "Geofencing",
  speedSensorLowBatteryAlerts: "Speed Sensor Low Battery Alerts",
  seatBeltSensorLowBatteryAlerts: "SeatBelt Sensor Low Battery Alerts",
  driverChangedAlerts: "Driver Changed Alerts",
  CriticalAlerts: "Critical Alerts ",
  frontRightAlerts: "FrontRight Alerts",
  rearRightAlerts: "RearRight Alerts",
};
